import Vue from 'vue'
import Router from 'vue-router'
import MainLayout from '@/layouts/MainLayout.vue'

Vue.use(Router)

const Login = () => import('@/views/Login.vue')
const Dashboard = () => import('@/views/Dashboard.vue')

// 占位页面（可替换为真实模块）
const OrgManage = () => import('@/views/org/OrgManage.vue')
const PersonList = () => import('@/views/hr/PersonList.vue')
const PersonDetail = () => import('@/views/hr/PersonDetail.vue')
const DeviceManage = () => import('@/views/device/DeviceManage.vue')
const VehicleManage = () => import('@/views/fleet/VehicleManage.vue')
const Attendance = () => import('@/views/oa/Attendance.vue')
const LocationMonitor = () => import('@/views/map/LocationMonitor.vue')
const Reports = () => import('@/views/report/Reports.vue')
const UserManage = () => import('@/views/auth/UserManage.vue')
const RoleManage = () => import('@/views/auth/RoleManage.vue')
const Settings = () => import('@/views/system/Settings.vue')

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/login', name:'Login', component: Login, meta:{ title:'登录' } },
    {
      path: '/', component: MainLayout, redirect: '/dashboard',
      children: [
        { path: '/dashboard', name:'Dashboard', component: Dashboard, meta:{ title:'首页', keepAlive:true } },
        

        { path: '/org/tree', name:'OrgManage', component: OrgManage, meta:{ title:'组织机构' } },

        { path: '/hr/persons', name:'PersonList', component: PersonList, meta:{ title:'人员花名册' } },
        { path: '/hr/persons/:id', name:'PersonDetail', component: PersonDetail, props:true, meta:{ title:'人员详情' } },

        { path: '/device/list', name:'DeviceManage', component: DeviceManage, meta:{ title:'设备列表' } },
        { path: '/fleet/vehicles', name:'VehicleManage', component: VehicleManage, meta:{ title:'车辆台账' } },
        { path: '/oa/attendance', name:'Attendance', component: Attendance, meta:{ title:'考勤记录' } },
        { path: '/map/monitor', name:'LocationMonitor', component: LocationMonitor, meta:{ title:'地图监控' } },
        { path: '/report/index', name:'Reports', component: Reports, meta:{ title:'运营报表' } },
        { path: '/auth/users', name:'UserManage', component: UserManage, meta:{ title:'用户管理' } },
        { path: '/auth/roles', name:'RoleManage', component: RoleManage, meta:{ title:'角色/权限' } },
        { path: '/system/settings', name:'Settings', component: Settings, meta:{ title:'系统设置' } },
      ]
    },
  ]
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (!token && to.path !== '/login') return next('/login')
  next()
})

export default router